import { render, staticRenderFns } from "./BaseForumField.vue?vue&type=template&id=db2c5a50&"
import script from "./BaseForumField.vue?vue&type=script&lang=js&"
export * from "./BaseForumField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports